import { useState, useEffect } from 'react';
import NetworkService from '../../NetworkService';

export const useAddressAutocomplete = (initialQuery = '', debounceDelay = 700) => {
  const [query, setQuery] = useState(initialQuery);
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery(query), debounceDelay);
    return () => clearTimeout(handler);
  }, [query, debounceDelay]);

  useEffect(() => {
    if (!debouncedQuery || debouncedQuery.length < 3) {
      setData([]);
      return;
    }

    let isMounted = true;
    setIsFetching(true);

    NetworkService.geocode(debouncedQuery, "SR", "Belgrade", "", "", 5)
      .then((res) => {
        if (isMounted) {
          setData(Array.isArray(res) ? res : res?.data || []);
        }
      })
      .catch(() => isMounted && setData([]))
      .finally(() => isMounted && setIsFetching(false));

    return () => { isMounted = false; };
  }, [debouncedQuery]);

  const options = data.map((item) => ({
    label: item.formattedAddress || item.display_name,
    value: `${item.lat},${item.lng || item.lon}`,
    lat: Number(item.lat),
    lng: Number(item.lng || item.lon),
    groupLabel: 'Addresses'
  }));

  return {
    options,
    isLoading: isFetching,
    onSearch: setQuery
  };
};
